import React from 'react';

// standard chip ui component
export default function Chip({ children, onClick }) {
  return children ? (
    <button
      className="btn btn-secondary btn-sm rounded-pill"
      style={{ width: 'fit-content' }}
      type="button"
      onClick={onClick ? onClick : () => {}}
    >
      <i className="bi bi-x-circle me-2"></i>
      {children}
    </button>
  ) : null;
}
